import { useIntl } from 'react-intl'

import { createLgbtModifiedLexeme } from 'functions/lgbt/createLgbtModifiedLexemes'
import {
  GQLDatingProfileLexicalOptionType,
  GQLGender,
} from 'generated-graphql/graphql'
import { useLgbtDetail } from 'hooks/useLgbtDetail'

/** Подменяет лексемы в зависимости от фичи 42: LGBT-тематика запрещена или изменена */
export const useModifyLgbtLexemes = (
  lexemes: GQLDatingProfileLexicalOptionType[],
  gender: GQLGender
) => {
  const { lgbtModified } = useLgbtDetail(gender)
  const intl = useIntl()

  if (!lexemes || !lgbtModified) {
    return lexemes
  }

  return lexemes.map((lexeme) => {
    const _lexeme = createLgbtModifiedLexeme(
      gender,
      lexeme.value!, // гендер того, кого ищут
      intl
    ).toLowerCase()

    return {
      ...lexeme,
      lexeme: _lexeme,
      maleLexeme: _lexeme,
      femaleLexeme: _lexeme,
    }
  })
}
